/* KeepItKodak — Terrace theme behaviour.
   Each block below powers one section; they only run when that section is on the page. */
(function () {
  'use strict';
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* Hero stack: arrows, swipe, "next shirt" peeking behind -------------- */
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var pos = root.querySelector('[data-hero-pos]');
    var open = root.querySelector('[data-hero-open]');
    if (!slides.length) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.classList.toggle('is-next', slides.length > 1 && k === (i + 1) % slides.length);
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = k === i ? 0 : -1; });
      });
      if (pos) pos.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      var url = slides[i].getAttribute('data-url');
      if (open && url) open.href = url;
    }
    root.querySelectorAll('[data-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { show(i - 1); }); });
    root.querySelectorAll('[data-hero-next]').forEach(function (b) { b.addEventListener('click', function () { show(i + 1); }); });
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
    });
    show(0);
  }

  /* New arrivals rail arrows -------------------------------------------- */
  function initRail(root) {
    var rail = root.querySelector('[data-rail]');
    if (!rail) return;
    var step = function () { return Math.max(300, rail.clientWidth * 0.8); };
    var back = root.querySelector('[data-rail-back]');
    var fwd = root.querySelector('[data-rail-fwd]');
    if (back) back.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (fwd) fwd.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* Kit Room collection chips ------------------------------------------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    function select(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  }

  /* Product page: photo switcher, details sheet, buy bar ---------------- */
  function initProduct(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-media]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var stage = root.querySelector('[data-stage]');
    var sheet = root.querySelector('[data-sheet]');
    var hint = root.querySelector('[data-hint]');
    function showMedia(n) {
      imgs.forEach(function (m, k) { m.classList.toggle('is-active', k === n); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === n ? 'true' : 'false'); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { showMedia(k); }); });
    function setSheet(open) {
      if (!sheet) return;
      sheet.hidden = !open;
      if (stage) {
        stage.setAttribute('aria-expanded', open ? 'true' : 'false');
        stage.setAttribute('aria-label', open ? 'Hide details' : 'Show details');
      }
      if (hint) hint.textContent = open ? 'Tap to close' : 'Tap for details';
    }
    if (stage) stage.addEventListener('click', function () { setSheet(sheet && sheet.hidden); });
    root.querySelectorAll('[data-sheet-close]').forEach(function (b) { b.addEventListener('click', function () { setSheet(false); }); });

    var form = root.querySelector('form.kik-bar');
    if (!form) return;
    var err = root.querySelector('[data-form-error]');
    var addBtn = form.querySelector('[data-add]');
    var buyBtn = form.querySelector('[data-buy-now]');
    var variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var ok = opt.getAttribute('data-available') === 'true';
        [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = !ok; });
        var price = root.querySelector('[data-price]');
        if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      });
    }
    function add() {
      if (err) err.textContent = '';
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag');
          return j;
        });
      });
    }
    function bumpCount() {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
    }
    if (addBtn) addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      add().then(function () { addBtn.textContent = 'In bag ✓'; bumpCount(); })
        .catch(function (x) { addBtn.disabled = false; if (err) err.textContent = x.message; });
    });
    if (buyBtn) buyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      buyBtn.disabled = true;
      add().then(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout'; })
        .catch(function (x) {
          // Already in the bag (one-of-ones): go straight to checkout anyway.
          if (/quantity|already|sold out|all \d+/i.test(x.message)) { window.location.href = '/checkout'; return; }
          buyBtn.disabled = false; if (err) err.textContent = x.message;
        });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-rail-section]').forEach(initRail);
    (scope || document).querySelectorAll('[data-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-pdp]').forEach(initProduct);
  }
  document.addEventListener('DOMContentLoaded', function () { boot(); });
  // Re-run when sections are edited in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
